/**
 * Hive Pre Loved — Homepage Nav Logo Animation
 *
 * On the homepage only:
 * - Initially: header logo is hidden, large white hero logo is visible
 * - On scroll (past threshold): header logo fades in, hero logo fades out
 * - On scroll back to top: reverses the animation
 *
 * On all other pages: no effect (header logo always visible)
 */

(function () {
  'use strict';

  const SCROLL_THRESHOLD = 50;
  const CLASS_INITIAL = 'hive-homepage-initial';
  const CLASS_SCROLLED = 'hive-homepage-scrolled';

  function init() {
    const body = document.body;

    // Set initial state — header logo hidden, hero logo visible
    body.classList.add(CLASS_INITIAL);
    body.classList.remove(CLASS_SCROLLED);

    let ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          const scrollY = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollY > SCROLL_THRESHOLD) {
            if (!body.classList.contains(CLASS_SCROLLED)) {
              body.classList.remove(CLASS_INITIAL);
              body.classList.add(CLASS_SCROLLED);
            }
          } else {
            if (!body.classList.contains(CLASS_INITIAL)) {
              body.classList.remove(CLASS_SCROLLED);
              body.classList.add(CLASS_INITIAL);
            }
          }

          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
